export default __webpack_public_path__ + "static/media/abrasivos_azul.f3d34d9a.png";